import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { actions as recipeActions } from 'src/state/recipe';
import RecipePicker from './presenter';
import Types from 'Types';
import { selectRecipes, selectIsFetchingRecipes } from 'src/state/recipe/selectors';
import { withRouter } from 'react-router-dom';

interface State {

}

const mapStateToProps = (state: Types.RootState, ownProps: State) => ({
  recipes: selectRecipes(state),
  isFetchingRecipes: selectIsFetchingRecipes(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Types.RootAction>) => bindActionCreators({
  fetchRecipes: recipeActions.fetchRecipes.request,
  submitRecipes: recipeActions.submitRecipeChoices.request
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RecipePicker));